import React from 'react';

import './fcmg-logos.scss';



const DecorFMCGLogos = () => {

    return (
        <>
            <div className='logos' id='fmcg-logos'>
                <a href='https://www.artlebedev.ru/gran-re/logo/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/fmcg/fmcg_1.png"/>
                </a>
                <a href='https://www.artlebedev.ru/syr-n-roll/logo/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/fmcg/fmcg_2.png"/>
                </a>
                <a href='https://www.artlebedev.ru/tulskaya-ptitsefabrika/identity/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/fmcg/fmcg_3.png"/>
                </a>
                <a href='https://www.artlebedev.ru/rev/duwi/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/fmcg/fmcg_4.png"/>
                </a>
                <a href='https://www.artlebedev.ru/malenkoe-schastye/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/fmcg/fmcg_5.png"/>
                </a>
                <a href='https://www.artlebedev.ru/yakitoriya/identity/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/fmcg/fmcg_6.png"/>
                </a>
                <a href='https://www.artlebedev.ru/spass-group/identity/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/fmcg/fmcg_7.png"/>
                </a>
                <a href='https://www.artlebedev.ru/remit/' target="_blank" className='logos__item'>
                    <img src="/competencies/images/target/fmcg/fmcg_8.png"/>
                </a>
            </div>
        </>
    );
}

export default DecorFMCGLogos;
